/**
 * How long before a "Resend code" button goes live, everywhere it appears.
 *
 * WHY IT IS A SHARED CONSTANT AND NOT A NUMBER IN EACH FILE. Three screens ask
 * for a six-digit code — the two-factor gate on the way in, the enrolment step
 * that sets the factor up, and the client portal's own challenge — and the wait
 * they impose is the same fact about the same mail path. It was written out
 * twice already (`LoginPage`, `MfaEnrollment`), which is exactly the point at
 * which a third copy stops being a duplicate and starts being a disagreement:
 * whichever screen the user happened to be on would tell them a different
 * number of seconds for the same restriction.
 *
 * WHY THERE IS A WAIT AT ALL, kept from `MfaEnrollment` where it was written:
 *
 * Not decoration. Pressing resend the moment the screen appears is the natural
 * reflex when a code has not arrived in five seconds, and it makes things
 * strictly worse: the newest code is the only valid one, so a second send
 * invalidates the first, and a user who then types the code from the FIRST
 * email — the one that has by now arrived — is rejected. They read that as "the
 * code does not work" and press resend again. The loop is self-sustaining and
 * every round burns an SMS segment or an email. On the phone factor it also
 * spends the `verificationId` the code in their hand belongs to.
 *
 * A minute is long enough for delivery to actually be the problem rather than
 * impatience, and the countdown says so rather than leaving a dead button to
 * be clicked at.
 *
 * Lives in `components/` beside `mask.ts`, for the same reason that one does:
 * its callers are in three different features, and putting it next to any one
 * of them would make the other two reach across.
 */
export const RESEND_COOLDOWN_SECONDS = 60;
